import AssociateFeedbackModalSection from '../../components/AssociateFeedbackComps/AssociateFeedbackModalSection';
import ShowAllAssociateFeedbacks from '../../components/AssociateFeedbackComps/ShowAllAssociateFeedbacks';
import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import AssociateFeedbackProvider from '../../contexts/AssociateFeedbackProvider';

const AssociateFeedback = () => {
  // rendering associate feedback page component here
  return (
    <>
      <PageTitle title='Associate Feedbacks' />

      <AssociateFeedbackProvider>
        <ShowAllAssociateFeedbacks />
        <AssociateFeedbackModalSection />
      </AssociateFeedbackProvider>
    </>
  );
};

export default AssociateFeedback;
